<template>
  <div class="bargain-detail" :class="{ inApp: $root.$data.isApp || this.$root.miniprogram }">
    <common-title titleName="砍价详情" :zIndex="1000" />
    <!-- 产品信息 -->
    <div class="hero-section">
      <div class="product-card">
        <div class="product-cover">
          <img class="cover-img" :src="getCoverUrl(activityInfo.coverMobile)" alt="" />
          <div class="participant-tag">
            已有{{ activityInfo.joinNum + activityInfo.virtualJoinNum }}人参与
          </div>
        </div>
        <div class="product-info">
          <div class="product-name">{{ activityInfo.productName }}</div>
          <div class="price-row">
            <span class="price-label">最低</span>
            <div class="floor-price">
              <span class="price-symbol">¥</span>
              <span class="price-value">{{ activityInfo.floorPrice }}</span>
            </div>
            <span class="original-price">¥{{ activityInfo.sellPrice }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- sku列表 -->
    <div v-if="(activityInfo.skuPriceList || []).length" class="sku-section">
      <div class="sku-list" v-if="activityInfo.skuPriceList.length > 1">
        <div
          v-for="item in activityInfo.skuPriceList"
          :key="item.productSkuId"
          class="sku-item"
          :class="{ 'sku-item--active': selectedSku.productSkuId === item.productSkuId }"
          @click="selectSku(item)"
        >
          <span class="sku-spec">{{ getSkuSpecText(item.specJson) }}</span>
        </div>
      </div>
    </div>

    <!-- 当前砍价的信息 -->
    <div
      v-if="selectedSku.productSkuId"
      class="progress-section"
      :class="{ 'progress-section--with-sku': (activityInfo.skuPriceList || []).length }"
    >
      <div class="cut-summary">
        <template v-if="isBargainReachedFloor">
          <span class="summary-text">已砍至底价!</span>
        </template>
        <template v-else>
          <span class="summary-text">已砍</span>
          <span class="summary-amount">¥{{ selectedSku.userSkuCutTotalAmount }}</span>
          <span class="summary-text">，还差</span>
          <span class="summary-amount">¥{{ remainAmount }}</span>
          <span class="summary-text">&nbsp;砍至底价</span>
        </template>
      </div>
      <div class="countdown-row">
        <span class="countdown-label">砍价倒计时：</span>
        <div class="countdown-block">
          {{ countdown.days }}
        </div>
        <span class="countdown-unit">天</span>
        <div class="countdown-block">
          {{ countdown.hours }}
        </div>
        <span class="countdown-sep">:</span>
        <div class="countdown-block">
          {{ countdown.minutes }}
        </div>
        <span class="countdown-sep">:</span>
        <div class="countdown-block">
          {{ countdown.seconds }}
        </div>
      </div>
      <div class="progress-wrap" ref="progressWrap">
        <div class="progress-bar">
          <div
            ref="progressFill"
            class="progress-fill"
            :style="{ width: progressFillWidth }"
          >
            <span class="progress-percent">{{ progressPercent }}%</span>
          </div>
        </div>
        <div
          v-show="progressPercent"
          ref="currentPriceBadge"
          class="current-price-badge"
          :style="{ left: currentPriceBadgeLeft + 'px' }"
        >
          <span>已砍至¥{{ selectedSku.userBargainPrice }}</span>
        </div>
      </div>

      <div class="price-axis">
        <div class="price-markers">
          <div class="floor-price-badge">
            <span class="price-original">¥{{ selectedSku.originalPrice }}</span>
            <span class="price-floor">¥{{ selectedSku.skuFloorPrice }}</span>
          </div>
          <div v-if="!isBargainReachedFloor" class="invite-tip">
            <span>邀请{{ remainHelpNumber }}位好友即可再砍¥{{ nextCutAmount }}</span>
          </div>
          <div v-else class="invite-tip">
            已砍至底价!
          </div>
        </div>
      </div>
    </div>

    <!-- 砍价阶梯 -->
    <div v-if="activityInfo.bargainMode != 2" class="tier-section">
      <div class="section-header"></div>
      <div class="tier-list">
        <div
          v-for="(tier, index) in tierStatusList"
          :key="index"
          class="tier-item"
          :class="'tier-item--' + tier.status"
        >
          <img
            v-if="tier.status === 'completed'"
            class="tier-icon"
            referrerpolicy="no-referrer"
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/success.png"
            alt=""
          />
          <div v-else class="tier-step">{{ index + 1 }}</div>
          <div class="tier-content">
            <span class="tier-title">邀请{{ tier.inviteNum }}人助力</span>
            <span class="tier-desc">可砍至¥{{ tier.price }}</span>
          </div>
          <span class="tier-status">{{ tier.statusText }}</span>
        </div>
      </div>
    </div>

    <div class="friends-section">
      <div class="section-header section-header--friends">
        <div class="header-left"></div>
        <div class="helper-count">
          <span>已有</span>
          <span class="helper-count-num">{{ activityInfo.currentAssistNum || 0 }}</span>
          <span>位好友帮砍</span>
        </div>
      </div>
      <div v-if="assistanceList.length" class="helper-list">
        <div
          v-for="item in displayedAssistanceList"
          :key="item.assistanceUserId"
          class="helper-item"
        >
          <img
            class="helper-avatar"
            referrerpolicy="no-referrer"
            :src="item.assistanceAvatar || defaultAvatar"
            alt=""
          />
          <span class="helper-name">{{ item.assistanceNickname }}</span>
        </div>
      </div>
      <div v-else class="helper-empty">快去邀请吧！</div>
      <div v-if="showHelperPagination" class="helper-pagination" @click="toggleHelperList">
        <img
          v-if="!helperListExpanded"
          class="pagination-arrow"
          referrerpolicy="no-referrer"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/down.png"
          alt=""
        />
        <img
          v-else
          class="pagination-arrow"
          referrerpolicy="no-referrer"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/up.png"
          alt=""
        />
      </div>
    </div>

    <div class="rules-section">
      <div class="section-header"></div>
      <div v-for="(rule, index) in ruleList" :key="index" class="rule-item">
        <div class="rule-index">{{ index + 1 }}</div>
        <span class="rule-text">{{ rule }}</span>
      </div>
    </div>

    <div class="recommend-section" v-if="recommendList.length">
      <div class="section-header"></div>
      <div class="recommend-list">
        <div
          v-for="item in recommendList"
          :key="item.id"
          class="recommend-item"
          @click="goRecommendDetail(item.id)"
        >
          <div
            class="recommend-cover"
            :style="{ backgroundImage: `url(${getCoverUrl(item.coverMobile)})` }"
          ></div>
          <div class="recommend-name">{{ item.productName }}</div>
          <div class="recommend-price-row">
            <div class="recommend-price">
              <span class="price-symbol">¥</span>
              <span class="price-value">{{ item.floorPrice }}</span>
            </div>
            <span class="recommend-original">¥{{ item.originalPrice }}</span>
          </div>
        </div>
      </div>
    </div>

    <div
      class="action-bar"
      :class="{ 'action-bar--reached-floor': isBargainReachedFloor && !isActivityActionDisabled }"
    >
      <button v-if="isActivityActionDisabled" class="action-btn action-btn--disabled" disabled>
        {{ actionBarDisabledText }}
      </button>
      <template v-else>
        <button
          v-if="!isBargainReachedFloor"
          class="action-btn action-btn--invite"
          @click="onInvite"
        >
          邀请好友帮砍
        </button>
        <button
          class="action-btn action-btn--buy"
          :class="{ 'action-btn--buy--reached-floor': isBargainReachedFloor }"
          @click="onBuy"
        >
          <span v-if="!isBargainReachedFloor" class="buy-price"
            >¥{{ selectedSku.userBargainPrice }}</span
          >
          <span v-else class="buy-countdown">倒计时：{{ countdownText }}</span>
          <span class="buy-text">直接购买</span>
        </button>
      </template>
    </div>

    <BargainSuccessPopup
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      @pay="onPayNow"
    />
    <BargainAssistancePopup
      :show="showAssistancePopup"
      :message="assistancePopupMsg"
      :success="assistanceSuccess"
      @close="onAssistancePopupClose"
      @join="onJoinActivity"
    />
    <CanvasImg :activityInfo="activityInfo" ref="canvasImg" />
  </div>
</template>

<script>
import { replaceHyphens, initCaptcha, triggerCaptcha } from '@/utils/tools';
import BargainSuccessPopup from './BargainSuccessPopup.vue';
import BargainAssistancePopup from './BargainAssistancePopup.vue';
import {
  reqBargainDetail,
  reqBargainShareRecord,
  reqBargainAssistance,
  reqBargainRecommend,
} from '@/api/personal';
import { reqIsBuyProduct } from '@/api/courseDetail/index';
import CanvasImg from './canvasImg.vue';
import { mapState } from 'vuex';
import Fingerprint2 from '@fingerprintjs/fingerprintjs';
import wx from 'weixin-js-sdk';

export default {
  components: {
    BargainSuccessPopup,
    BargainAssistancePopup,
    CanvasImg,
  },
  data() {
    return {
      showSuccessPopup: false,
      showAssistancePopup: false,
      assistancePopupMsg: '',
      assistanceSuccess: false,
      activityInfo: {},
      assistanceList: [],
      defaultAvatar: require('@/assets/img/personalImg/defaultAvatar.png'),
      recommendList: [],
      selectedSku: {},
      ruleList: [
        '发起砍价后需在活动有效期内完成，过期自动失效',
        '每位好友只能帮砍一次',
        '砍至底价后需活动有效期内支付，逾期恢复原价',
        '砍价商品数量有限，先到先得',
        '如发现作弊行为，平台有权取消活动资格',
      ],
      countdownText: '00:00:00',
      countdown: {
        days: '0',
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
      nowTime: new Date().getTime(),
      countdownTimer: null,
      nvcData: null,
      ncSuccessData: {},
      FingerprintData: {},
      helperListExpanded: false,
      buyStatus: [],
      currentPriceBadgeLeft: 0,
    };
  },
  computed: {
    ...mapState(['userInfo']),
    remainAmount() {
      const { originalPrice, userSkuCutTotalAmount, skuFloorPrice } = this.selectedSku;
      const amount = originalPrice - skuFloorPrice - Number(userSkuCutTotalAmount);
      return amount > 0 ? amount.toFixed(2) : '0.00';
    },
    tierStatusList() {
      const statusMap = {
        completed: '已完成',
        active: '进行中',
        pending: '待完成',
      };
      const tierPrices = this.selectedSku.tierPrices || [];
      const { shareRecordId, currentAssistNum: assistNum } = this.activityInfo;
      const currentAssistNum = Number(assistNum) || 0;
      const isActivityEndedNotReached = this.isActivityEnded && !this.isBargainReachedFloor;

      return tierPrices.map((item, index) => {
        let status = 'pending';
        if (shareRecordId) {
          const inviteNum = Number(item.inviteNum) || 0;
          const prevInviteNum = index > 0 ? Number(tierPrices[index - 1].inviteNum) || 0 : 0;
          if (currentAssistNum >= inviteNum) {
            status = 'completed';
          } else if (currentAssistNum >= prevInviteNum) {
            status = 'active';
          }
        }
        if (isActivityEndedNotReached) {
          status = 'pending';
        }
        return {
          ...item,
          status,
          statusText: isActivityEndedNotReached ? '未完成' : statusMap[status],
        };
      });
    },
    progressPercent() {
      const { tierPrices } = this.selectedSku;
      const { currentAssistNum } = this.activityInfo;
      const total = tierPrices?.[tierPrices?.length - 1]?.inviteNum || 0;
      if (!total) return 0;
      const percent = Math.floor((currentAssistNum / total) * 100);
      return percent > 100 ? 100 : percent < 0 ? 0 : percent;
    },
    progressFillWidth() {
      const percent = this.progressPercent;
      // 保证百分比文字可见
      return `${Math.max(percent, 12)}%`;
    },
    nextCutAmount() {
      const currentTier =
        this.tierStatusList.find((tier) => tier.status === 'active') ||
        this.tierStatusList.find((tier) => tier.status === 'pending');
      if (!currentTier) return '0.00';
      const currentPrice = Number(this.selectedSku.userBargainPrice) || 0;
      const tierPrice = Number(currentTier.price) || 0;
      const amount = currentPrice - tierPrice;
      return amount > 0 ? amount.toFixed(2) : '0.00';
    },
    remainHelpNumber() {
      const currentAssistNum = Number(this.activityInfo.currentAssistNum) || 0;
      const currentTier =
        this.tierStatusList.find((tier) => tier.status === 'active') ||
        this.tierStatusList.find((tier) => tier.status === 'pending');
      if (!currentTier) return 0;
      const remain = Number(currentTier.inviteNum) - currentAssistNum;
      return remain > 0 ? remain : 0;
    },
    isBargainReachedFloor() {
      const current = Number(this.selectedSku.userBargainPrice);
      const floor = Number(this.selectedSku.skuFloorPrice);
      if (Number.isNaN(current) || Number.isNaN(floor)) return false;
      return current === floor;
    },
    isActivityClosed() {
      return Number(this.activityInfo.status) === 5;
    },
    isActivityNotStarted() {
      return Number(this.activityInfo.status) === 6;
    },
    isActivityEnded() {
      return Number(this.activityInfo.status) === 8;
    },
    isPurchased() {
      const { status, canParticipate } = this.activityInfo;
      if (Number(status) === 7 && canParticipate === false) return true;
      // if (Number(isRepeatBuy) === 0 && this.buyStatus.length) return true;
      return false;
    },
    isActivityActionDisabled() {
      return (
        this.isPurchased ||
        this.isActivityClosed ||
        this.isActivityNotStarted ||
        this.isActivityEnded ||
        this.isProductOffShelf ||
        this.isProductSoldOut
      );
    },
    isProductOffShelf() {
      return Number(this.activityInfo.productStatus) === 6;
    },
    isProductSoldOut() {
      const { isSetStock, remainStockNum } = this.selectedSku;
      return Number(isSetStock) === 1 && Number(remainStockNum) <= 0;
    },
    actionBarDisabledText() {
      if (this.isPurchased) return '已购买';
      if (this.isActivityClosed) return '活动已关闭';
      if (this.isActivityNotStarted) return '活动未开始';
      if (this.isActivityEnded) return '活动已结束';
      if (this.isProductOffShelf) return '产品已下架';
      if (this.isProductSoldOut) return '已售罄';
      return '';
    },
    showHelperPagination() {
      return this.assistanceList.length > 5;
    },
    displayedAssistanceList() {
      if (this.helperListExpanded || !this.showHelperPagination) {
        return this.assistanceList;
      }
      return this.assistanceList.slice(0, 5);
    },
  },
  watch: {
    '$route.query.activityId'(activityId) {
      if (activityId) {
        this.getDetail();
      }
    },
    progressFillWidth() {
      this.$nextTick(() => this.updateCurrentPriceBadgePosition());
    },
    'selectedSku.userBargainPrice'() {
      this.$nextTick(() => this.updateCurrentPriceBadgePosition());
    },
  },
  mounted() {
    Fingerprint2.load().then((res) => {
      res.get().then((data) => {
        this.FingerprintData = data;
      });
    });
    this.initPage();
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
    window.addEventListener('resize', this.updateCurrentPriceBadgePosition);
  },
  destroyed() {
    clearInterval(this.countdownTimer);
    window.removeEventListener('resize', this.updateCurrentPriceBadgePosition);
  },
  methods: {
    updateCurrentPriceBadgePosition() {
      const wrap = this.$refs.progressWrap;
      const badge = this.$refs.currentPriceBadge;
      const fill = this.$refs.progressFill;
      if (!wrap || !badge || !fill) return;
      const wrapWidth = wrap.clientWidth;
      const badgeWidth = badge.offsetWidth;
      if (!wrapWidth || !badgeWidth) return;
      // 进度条右端中心对齐，并限制在容器内
      const tipX = fill.offsetWidth;
      const left = Math.max(0, Math.min(wrapWidth - badgeWidth, tipX - badgeWidth / 2));
      this.currentPriceBadgeLeft = left;
    },
    async initPage() {
      const userInfo = this.userInfo?.id ? this.userInfo : await this.$root.getUserInfo();
      if (!userInfo?.id) {
        this.redirectToLogin();
        return;
      }

      await this.getDetail();
      const { shareRecordId } = this.$route.query;
      if (!shareRecordId) return;

      initCaptcha('y0p990dn', this.navCallback);
      await this.$nextTick();
      setTimeout(() => {
        triggerCaptcha();
      }, 300);
    },
    navCallback(data) {
      this.nvcData = data;
      this.assistance();
    },
    async assistance() {
      const { shareRecordId, activityId } = this.$route.query;
      const res = await reqBargainAssistance({
        captchaVerifyParam: this.nvcData,
        shareRecordId,
        activityId,
        sessionId: this.ncSuccessData.sessionId,
        sig: this.ncSuccessData.sig,
        token: this.ncSuccessData.token,
        ua: navigator.userAgent,
        visitorId: this.FingerprintData.visitorId,
        sceneId: 'y0p990dn',
      });
      if (res.code === 0) {
        this.assistanceSuccess = true;
        this.assistancePopupMsg = '已助力成功，快来一起参与活动吧～';
        this.showAssistancePopup = true;
      } else {
        this.assistanceSuccess = false;
        this.assistancePopupMsg = res.msg || '助力失败';
        this.showAssistancePopup = true;
      }
    },
    redirectToLogin() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('login');
        return;
      }
      if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        const params = (searchParams || '').split('&');
        const paramsMap = new Map();
        params.forEach((item) => {
          const [key, value] = item.split('=');
          if (key) {
            paramsMap.set(key, value);
          }
        });
        const entries = paramsMap.entries();
        let query = '';
        const excludeQueryArr = ['THIRD_SESSION', 'env'];
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of entries) {
          if (!excludeQueryArr.includes(key)) query += `${key}=${value}&`;
        }
        url = `${domain}?${query}`;
        const redirctUrl = encodeURIComponent(
          `/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
        return;
      }
      const { path, query } = this.$route;
      this.$router.replace({
        path: '/registrationLogin',
        query: {
          redirect: path,
          ...query,
        },
      });
    },
    onAssistancePopupClose() {
      this.showAssistancePopup = false;
    },
    onJoinActivity() {
      this.showAssistancePopup = false;
      const { activityId } = this.$route.query;
      this.$router.replace({
        path: this.$route.path,
        query: { activityId },
      });
    },
    async getDetail() {
      const res = await reqBargainDetail(this.$route.query.activityId);
      if (res.code === 0) {
        this.nowTime = res.currentTime || new Date().getTime();
        const { assistanceList, skuPriceList } = res.data;
        this.activityInfo = res.data;
        this.assistanceList = assistanceList || [];
        if (skuPriceList?.length) {
          const { skuId } = this.$route.query;
          const matchedSku = skuId
            ? skuPriceList.find((item) => Number(item.productSkuId) === Number(skuId))
            : null;
          this.selectedSku = matchedSku || skuPriceList[0];
        }
        this.initCountdown();
        this.checkBargainSuccess();
        this.getRecommendList();
        this.$nextTick(() => this.updateCurrentPriceBadgePosition());
        // this.checkBuyCourse();
      }
    },
    // async checkBuyCourse() {
    //   const { productId, isRepeatBuy } = this.activityInfo;
    //   if (!productId) return;
    //   const res = await reqIsBuyProduct(productId);
    //   if (res.code === 0) {
    //     if (Number(isRepeatBuy) !== 1) {
    //       this.buyStatus = res.data || [];
    //     }
    //   }
    // },
    async getRecommendList() {
      const activityId = this.$route.query.activityId;
      const res = await reqBargainRecommend({ activityId, company: 0 });
      if (res.code === 0) {
        this.recommendList = res.data || [];
      }
    },

    checkBargainSuccess() {
      if (this.isBargainReachedFloor & !this.isPurchased) {
        this.showSuccessPopup = true;
      }
    },
    initCountdown() {
      clearInterval(this.countdownTimer);
      const currentTime = this.parseTime(this.nowTime);
      const endTime = this.parseTime(this.activityInfo.endTime);
      if (!currentTime || !endTime) {
        this.countdownText = '00:00:00';
        this.countdown = { days: '0', hours: '00', minutes: '00', seconds: '00' };
        return;
      }
      let remain = endTime - currentTime;

      const updateCountdown = () => {
        if (remain <= 0) {
          this.countdownText = '00:00:00';
          this.countdown = { days: '0', hours: '00', minutes: '00', seconds: '00' };
          clearInterval(this.countdownTimer);
          return;
        }
        const days = Math.floor(remain / 1000 / 60 / 60 / 24);
        const hours = String(Math.floor((remain / 1000 / 60 / 60) % 24)).padStart(2, '0');
        const minutes = String(Math.floor((remain / 1000 / 60) % 60)).padStart(2, '0');
        const seconds = String(Math.floor((remain / 1000) % 60)).padStart(2, '0');
        this.countdown = {
          days: String(days),
          hours,
          minutes,
          seconds,
        };
        this.countdownText =
          days > 0 ? `${days}天${hours}:${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`;
      };

      updateCountdown();
      this.countdownTimer = setInterval(() => {
        remain -= 1000;
        updateCountdown();
      }, 1000);
    },
    getCoverUrl(coverMobile = '') {
      return String(coverMobile).split(',')[0] || '';
    },
    getSkuSpecText(specJson) {
      try {
        const list = JSON.parse(specJson || '[]');
        return list
          .map((item) => item.value)
          .filter(Boolean)
          .join('，');
      } catch (e) {
        return '';
      }
    },
    selectSku(item) {
      this.selectedSku = item;
      this.$nextTick(() => this.updateCurrentPriceBadgePosition());
    },
    toggleHelperList() {
      this.helperListExpanded = !this.helperListExpanded;
    },
    parseTime(time) {
      if (time === null || time === undefined || time === '') return NaN;
      if (typeof time === 'number') return time;
      const timestamp = new Date(replaceHyphens(String(time))).getTime();
      return Number.isNaN(timestamp) ? NaN : timestamp;
    },
    async onInvite() {
      const { id, shareRecordId } = this.activityInfo;
      if (!shareRecordId) {
        const res = await reqBargainShareRecord({
          activityId: id,
          skuId: this.selectedSku.productSkuId,
        });
        if (res.code !== 0) {
          this.$toast(res.msg || '分享失败');
          return;
        }
        if (res.data) {
          this.activityInfo = {
            ...this.activityInfo,
            shareRecordId: res.data.shareRecordId,
          };
        }
      }
      if (this.$root.miniprogram) {
        // const temps = {
        //   activityId:id,
        //   shareRecordId,
        //   activitySharePicture:this.activityInfo.shareImg
        // };
        // const jsonString = JSON.stringify(temps);
        // const encodedValue = encodeURIComponent(jsonString);
        wx.miniProgram.navigateTo({
          url: `/circle/bargainShare/index?activityId=${id}&shareRecordId=${shareRecordId}&activitySharePicture=${this.activityInfo.shareImg}`,
        });
      } else {
        this.$refs.canvasImg.createImg();
      }
    },
    onBuy() {
      const { productId } = this.activityInfo;
      const { productSkuId: skuId } = this.selectedSku;
      this.$router.push({
        path: '/payOrder',
        query: {
          product: JSON.stringify([
            {
              productId,
              skuId,
            },
          ]),
        },
      });
    },
    onPayNow() {
      this.showSuccessPopup = false;
      this.onBuy();
    },
    goRecommendDetail(activityId) {
      this.$router.replace({
        path: '/personalCenter/bargainDetail',
        query: { activityId },
      });
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.initPage();
    },
    // ios 处理登录回调
    getLogin(APPSESSION) {
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bargain-detail.inApp {
  padding-top: 0;
}
.bargain-detail {
  min-height: 100vh;
  padding-top: 100px;
  padding-bottom: 192px;
  background-color: #fcd9eb;

  .hero-section {
    position: relative;
    height: 370px;
    padding: 54px 29px 150px 29px;
    background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/top-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;

    // .hero-title {
    //   margin-left: 11px;
    //   color: #222;
    //   font-size: 80px;
    //   line-height: 96px;
    //   white-space: nowrap;
    // }

    // .hero-subtitle {
    //   display: inline-block;
    //   margin-top: 7px;
    //   padding: 7px 161px 9px 29px;
    //   background: url(https://lanhu-oss-2537-2.lanhuapp.com/SketchPnge3750b25c90af36dd33324a0b986e2ddc21bf886bdaf10d73bc59fcb83a391d9)
    //     100% no-repeat;
    //   background-size: 100% 100%;
    //   color: #222;
    //   font-weight: 500;
    //   font-size: 33px;
    //   line-height: 45px;
    //   white-space: nowrap;
    // }

    .product-card {
      position: absolute;
      top: 261px;
      right: 36px;
      left: 36px;
      display: flex;
      height: 196px;
      padding: 29px;
      background-color: #fff;
      border-radius: 18px;

      .product-cover {
        position: relative;
        flex-shrink: 0;
        width: 188px;
        height: 137px;
        background: #ddd;
        border-radius: 10px;

        .cover-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .participant-tag {
          position: absolute;
          bottom: 7px;
          left: 7px;
          padding: 2px 7px;
          color: #fff;
          font-weight: 500;
          font-size: 18px;
          line-height: 25px;
          white-space: nowrap;
          background-color: rgba(31, 32, 46, 0.6);
          border-radius: 5px;
        }
      }

      .product-info {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-self: stretch;
        min-width: 0;
        margin-left: 18px;

        .product-name {
          display: -webkit-box;
          overflow: hidden;
          color: #333;
          font-weight: 500;
          font-size: 25px;
          line-height: 33px;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .price-row {
          display: flex;
          align-items: flex-end;
          margin-top: auto;

          .price-label {
            margin-bottom: 4px;
            color: #ff3938;
            font-size: 18px;
            line-height: 25px;
          }

          .floor-price {
            display: flex;
            align-items: baseline;
            margin-left: 4px;
            line-height: 36px;

            .price-symbol {
              color: #ff3938;
              font-weight: 600;
              font-size: 25px;
            }

            .price-value {
              color: #ff3938;
              font-weight: 600;
              font-size: 36px;
              line-height: 36px;
            }
          }

          .original-price {
            margin-bottom: 4px;
            margin-left: 7px;
            color: #ccc;
            font-size: 18px;
            line-height: 25px;
            text-decoration: line-through;
          }
        }
      }
    }
  }

  .sku-section {
    width: 677px;
    max-width: calc(100% - 72px);
    margin: 109px auto 0;

    .sku-list {
      display: flex;
      flex-wrap: nowrap;
      padding-bottom: 9px;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      .sku-item {
        position: relative;
        flex-shrink: 0;
        padding: 12px 15px;
        color: #333;
        font-size: 25px;
        line-height: 36px;
        background-color: #fff;
        border-radius: 11px;

        & + .sku-item {
          margin-left: 14px;
        }

        &--active {
          color: #fff;
          background: linear-gradient(90deg, #ff2919 0%, #ff76a0 100%);

          &::after {
            position: absolute;
            bottom: -9px;
            left: 50%;
            width: 25px;
            height: 9px;
            background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/arrow.png')
              no-repeat center / 100% 100%;
            transform: translateX(-50%);
            content: '';
          }
        }

        .sku-spec {
          display: block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .progress-section {
    width: 677px;
    max-width: calc(100% - 72px);
    margin: 109px auto 0;
    padding: 36px 29px 33px;
    background-color: #fff;
    border-radius: 18px;

    &--with-sku {
      margin-top: 22px;
    }

    .cut-summary {
      font-weight: 500;
      font-size: 0;
      line-height: 40px;
      white-space: nowrap;
      text-align: center;

      .summary-text {
        color: #333;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
      }

      .summary-amount {
        color: #ff3938;
        font-weight: 600;
        font-size: 29px;
        line-height: 40px;
      }
    }

    .countdown-row {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      white-space: nowrap;

      .countdown-label {
        color: #999;
        font-size: 25px;
        line-height: 36px;
      }

      .countdown-block {
        width: 36px;
        height: 36px;
        margin-left: 7px;
        color: #fff;
        font-weight: 500;
        font-size: 22px;
        line-height: 36px;
        text-align: center;
        background-color: #ff7f41;
        border-radius: 7px;

        &:first-of-type {
          margin-left: 0;
        }
      }

      .countdown-num {
        color: #fff;
        font-weight: 500;
        font-size: 22px;
        line-height: 31px;
      }

      .countdown-unit {
        margin-left: 7px;
        color: #333;
        font-size: 25px;
        line-height: 36px;
      }

      .countdown-sep {
        margin-left: 7px;
        color: #333;
        font-size: 25px;
        line-height: 36px;
      }
    }

    .progress-wrap {
      position: relative;
      margin-top: 29px;
      padding-bottom: 20px;
    }

    .progress-bar {
      height: 36px;
      overflow: hidden;
      background: #f1f1f1;
      border-radius: 18px;

      .progress-fill {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        box-sizing: border-box;
        min-width: 80px;
        height: 100%;
        padding: 2px 24px 4px 0;
        background: linear-gradient(90deg, #ff4b4b 0%, #ff2453 100%);
        border-radius: 18px;
      }

      .progress-percent {
        color: #fff;
        font-weight: 600;
        font-size: 22px;
        line-height: 31px;
        white-space: nowrap;
      }
    }

    .current-price-badge {
      position: absolute;
      top: 47px;
      z-index: 1;
      height: 43px;
      padding: 4px 11px;
      color: #fff;
      font-weight: 500;
      font-size: 25px;
      line-height: 36px;
      white-space: nowrap;
      background: linear-gradient(90deg, #ff2919 0%, #ff76a0 100%);
      border-radius: 8px;

      &::before {
        position: absolute;
        top: -8px;
        left: 50%;
        width: 0;
        height: 0;
        border-right: 8px solid transparent;
        border-bottom: 8px solid #ff4a5f;
        border-left: 8px solid transparent;
        transform: translateX(-50%);
        content: '';
      }
    }

    .price-axis {
      .price-original {
        flex-shrink: 0;
        margin-top: 4px;
        color: #999;
        font-weight: 500;
        font-size: 22px;
        line-height: 31px;
        white-space: nowrap;
      }

      .price-floor {
        padding: 0 10px;
        color: #fff;
        font-weight: 500;
        font-size: 22px;
        line-height: 36px;
        background: linear-gradient(90deg, #ff2919 0%, #ff76a0 100%);
        border-radius: 18px;
      }

      .floor-price-badge {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .invite-tip {
        width: fit-content;
        margin: 18px auto 0;
        padding: 4px 36px;
        color: #682800;
        font-size: 25px;
        line-height: 43px;
        white-space: nowrap;
        text-align: center;
        background-color: #fffbd5;
        border-radius: 4px;
      }
    }
  }

  .tier-section,
  .friends-section,
  .rules-section,
  .recommend-section {
    width: 677px;
    max-width: calc(100% - 72px);
    margin: 22px auto 0;
    overflow: hidden;
    background-color: #fff;
    border-radius: 18px;
  }

  .section-header {
    display: flex;
    align-items: center;
    height: 91px;
    padding: 27px 29px;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .section-title {
      color: #131834;
      font-weight: 700;
      font-size: 33px;
      line-height: 36px;
      white-space: nowrap;
    }

    .section-icon {
      width: 31px;
      height: 31px;
      margin-top: 2px;
      margin-left: 7px;
      background-repeat: no-repeat;
      background-size: 100% 100%;

      &--tier {
        background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/899138c94eac4e48b02bf872548bfe09_mergeImage.png);
      }

      &--friends {
        background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/rule-bg4.png');
      }

      &--rules {
        background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/bb6515a133e742f8b94680c9aad61702_mergeImage.png);
      }

      &--recommend {
        background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/18976bf4a9744a71b843ae2893a86598_mergeImage.png);
      }
    }

    &--friends {
      justify-content: space-between;
      background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/rule-bg4.png');

      .header-left {
        display: flex;
        align-items: center;
      }

      .helper-count {
        font-size: 25px;
        line-height: 36px;
        white-space: nowrap;

        .helper-count-num {
          padding: 0 2px;
          color: #ff3938;
          font-weight: 600;
        }
      }
    }
  }

  .tier-section .section-header {
    background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/rule-bg1.png');
  }

  .rules-section .section-header {
    background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/rule-bg2.png');
  }

  .recommend-section .section-header {
    background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/rule-bg3.png');
  }

  .tier-list {
    padding: 0 29px 29px;

    .tier-item {
      display: flex;
      align-items: center;
      margin-top: 22px;
      padding: 13px 27px 13px 24px;
      border-radius: 14px;

      &:first-child {
        margin-top: 22px;
      }

      &--completed {
        background-color: #e8fff1;
        border: 1px solid #b3ebc9;

        .tier-desc {
          color: #666;
        }

        .tier-status {
          color: #00ca51;
        }
      }

      &--active {
        background-color: #fff3f3;
        border: 1px solid #ffc4c3;

        .tier-desc {
          color: #ff3938;
        }

        .tier-status {
          color: #ff3938;
        }
      }

      &--pending {
        background-color: #f0f1f6;
        border: 1px solid #dcdfea;

        .tier-desc {
          color: #666;
        }

        .tier-status {
          color: #999;
        }
      }

      .tier-icon {
        flex-shrink: 0;
        width: 54px;
        height: 54px;
      }

      .tier-step {
        flex-shrink: 0;
        width: 54px;
        height: 54px;
        color: #fff;
        font-weight: 600;
        font-size: 36px;
        line-height: 54px;
        text-align: center;
        border-radius: 50%;
      }

      &--active .tier-step {
        background-color: #ff3938;
      }

      &--pending .tier-step {
        background-color: #c0c4d4;
      }

      .tier-content {
        flex: 1;
        min-width: 0;
        margin-left: 18px;

        .tier-title {
          display: block;
          color: #333;
          font-weight: 500;
          font-size: 29px;
          line-height: 40px;
          white-space: nowrap;
        }

        .tier-desc {
          display: block;
          margin-top: 4px;
          font-size: 25px;
          line-height: 36px;
          white-space: nowrap;
        }
      }

      .tier-status {
        flex-shrink: 0;
        margin-left: 18px;
        font-weight: 500;
        font-size: 25px;
        line-height: 36px;
        white-space: nowrap;
      }
    }
  }

  .helper-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px 0;
    padding: 29px 29px 0;

    .helper-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 10px;

      .helper-avatar {
        width: 109px;
        height: 109px;
        object-fit: cover;
        border-radius: 50%;
      }

      .helper-name {
        max-width: 120px;
        margin-top: 11px;
        overflow: hidden;
        color: #333;
        font-size: 25px;
        line-height: 36px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .helper-empty {
    padding: 20px 29px 29px;
    color: #999;
    font-size: 25px;
    line-height: 36px;
    text-align: center;
  }

  .helper-pagination {
    display: flex;
    justify-content: center;
    padding: 22px 0 29px;
    cursor: pointer;

    .pagination-arrow {
      width: 43px;
      height: 22px;
    }
  }

  .rules-section {
    padding-bottom: 36px;

    .rule-item {
      display: flex;
      align-items: flex-start;
      margin-top: 14px;
      padding: 0 29px;

      &:first-of-type {
        margin-top: 22px;
      }

      .rule-index {
        flex-shrink: 0;
        width: 29px;
        height: 29px;
        margin-top: 4px;
        color: #fff;
        font-weight: 600;
        font-size: 22px;
        line-height: 31px;
        text-align: center;
        background-color: #ff7f41;
        border-radius: 50%;
      }

      .rule-text {
        flex: 1;
        margin-left: 14px;
        color: #333;
        font-size: 25px;
        line-height: 36px;
      }
    }
  }

  .recommend-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 29px 29px 33px;

    .recommend-item {
      display: flex;
      flex-direction: column;
      width: 300px;
      min-height: 346px;
      margin-bottom: 36px;

      .recommend-cover {
        flex-shrink: 0;
        width: 100%;
        height: 216px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: 11px;
      }

      .recommend-name {
        display: -webkit-box;
        flex: 1;
        min-height: 66px;
        margin-top: 14px;
        overflow: hidden;
        color: #333;
        font-weight: 500;
        font-size: 25px;
        line-height: 33px;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }

      .recommend-price-row {
        display: flex;
        flex-shrink: 0;
        align-items: flex-end;
        margin-top: auto;
        padding-top: 14px;

        .recommend-price {
          display: flex;
          align-items: baseline;
          line-height: 36px;

          .price-symbol {
            color: #ff3938;
            font-weight: 600;
            font-size: 25px;
          }

          .price-value {
            color: #ff3938;
            font-weight: 600;
            font-size: 36px;
            line-height: 36px;
          }
        }

        .recommend-original {
          margin-bottom: 4px;
          margin-left: 7px;
          color: #ccc;
          font-size: 18px;
          line-height: 25px;
          text-decoration: line-through;
        }
      }
    }
  }

  .action-bar {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    padding: 18px 40px 34px;
    background-color: #fff;
    border-radius: 36px 36px 0 0;
    box-shadow: 0 -2px 7px rgba(0, 0, 0, 0.1);

    .action-btn {
      border-radius: 50px;
      outline: none;
      cursor: pointer;

      &--invite {
        flex-shrink: 0;
        width: 316px;
        padding: 24px 0;
        color: #fff;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
        background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/foot-btn1.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        border: none;
      }

      &--disabled {
        flex: 1;
        width: 100%;
        padding: 24px 0;
        color: #fff;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
        background-color: #eee;
        border: none;
        cursor: not-allowed;
      }

      &--buy {
        position: relative;
        flex: 1;
        margin-left: 18px;
        padding: 9px 0 18px;
        background-color: #fff;
        border: 1px solid rgba(255, 57, 56, 1);

        .buy-price,
        .buy-countdown {
          position: absolute;
          top: 9px;
          left: 50%;
          color: #ff3938;
          font-weight: 500;
          font-size: 22px;
          line-height: 31px;
          white-space: nowrap;
          transform: translateX(-50%);
        }

        .buy-text {
          display: block;
          margin-top: 29px;
          color: #ff3938;
          font-weight: 500;
          font-size: 29px;
          line-height: 40px;
          text-align: center;
        }

        &--reached-floor {
          flex: 1;
          margin-left: 0;
          background-color: rgba(255, 57, 56, 1);
          border-color: rgba(255, 57, 56, 1);

          .buy-countdown,
          .buy-text {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
<style>
.sm-pop-inner.nc-container {
  width: 80%;
}
</style>
